"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.set = exports.get = void 0;
const _LOCAL_STORAGE_KEY = `browserless-debugger:` + window.location.origin + window.location.pathname;
const hasLocalStorage = (() => {
    let can;
    try {
        window.localStorage.getItem(_LOCAL_STORAGE_KEY);
        can = true;
    }
    catch (e) {
        console.error(`Error writing to local-storage: ${e}`);
        can = false;
    }
    return can;
})();
const state = (() => {
    const prior = hasLocalStorage ? window.localStorage.getItem(_LOCAL_STORAGE_KEY) : '{}';
    let priorState;
    try {
        priorState = JSON.parse(prior || '{}');
    }
    catch (_a) {
        priorState = {};
    }
    return priorState;
})();
const writeState = (value) => {
    if (hasLocalStorage) {
        window.localStorage.setItem(_LOCAL_STORAGE_KEY, JSON.stringify(value));
    }
};
const get = (key) => state.hasOwnProperty(key) ? state[key] : null;
exports.get = get;
const set = (key, value) => {
    state[key] = value;
    writeState(state);
    return value;
};
exports.set = set;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9zdG9yYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLE1BQU0sa0JBQWtCLEdBQUcsdUJBQXVCLEdBQUcsTUFBTSxDQUFDLFFBQVEsQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUM7QUFDdkcsTUFBTSxlQUFlLEdBQUcsQ0FBQyxHQUFHLEVBQUU7SUFDNUIsSUFBSSxHQUFZLENBQUM7SUFFakIsSUFBSTtRQUNGLE1BQU0sQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLGtCQUFrQixDQUFDLENBQUM7UUFDaEQsR0FBRyxHQUFHLElBQUksQ0FBQztLQUNaO0lBQUMsT0FBTSxDQUFDLEVBQUU7UUFDVCxPQUFPLENBQUMsS0FBSyxDQUFDLG1DQUFtQyxDQUFDLEVBQUUsQ0FBQyxDQUFDO1FBQ3RELEdBQUcsR0FBRyxLQUFLLENBQUM7S0FDYjtJQUVELE9BQU8sR0FBRyxDQUFDO0FBQ2IsQ0FBQyxDQUFDLEVBQUUsQ0FBQztBQUVMLE1BQU0sS0FBSyxHQUF3QixDQUFDLEdBQUcsRUFBRTtJQUN2QyxNQUFNLEtBQUssR0FBRyxlQUFlLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLGtCQUFrQixDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztJQUN2RixJQUFJLFVBQWtDLENBQUM7SUFFdkMsSUFBSTtRQUNGLFVBQVUsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQUssSUFBSSxJQUFJLENBQUMsQ0FBQztLQUN4QztJQUFDLFdBQU07UUFDTixVQUFVLEdBQUcsRUFBRSxDQUFDO0tBQ2pCO0lBRUQsT0FBTyxVQUFVLENBQUM7QUFDcEIsQ0FBQyxDQUFDLEVBQUUsQ0FBQztBQUVMLE1BQU0sVUFBVSxHQUFHLENBQUMsS0FBMEIsRUFBRSxFQUFFO0lBQ2hELElBQUksZUFBZSxFQUFFO1FBQ25CLE1BQU0sQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLGtCQUFrQixFQUFFLElBQUksQ0FBQyxTQUFTLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQztLQUN4RTtBQUNILENBQUMsQ0FBQztBQUdLLE1BQU0sR0FBRyxHQUFHLENBQUMsR0FBVyxFQUFFLEVBQUUsQ0FBQyxLQUFLLENBQUMsY0FBYyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztBQUFyRSxRQUFBLEdBQUcsT0FBa0U7QUFFM0UsTUFBTSxHQUFHLEdBQUcsQ0FBSSxHQUFXLEVBQUUsS0FBTyxFQUFLLEVBQUU7SUFDaEQsS0FBSyxDQUFDLEdBQUcsQ0FBQyxHQUFHLEtBQUssQ0FBQztJQUNuQixVQUFVLENBQUMsS0FBSyxDQUFDLENBQUM7SUFFbEIsT0FBTyxLQUFLLENBQUM7QUFDZixDQUFDLENBQUM7QUFMVyxRQUFBLEdBQUcsT0FLZCJ9